/*
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu.
 */

// Initiate the menus when the DOM loads.
document.addEventListener( 'DOMContentLoaded', function () {
	initMainNavigation();
} );

/**
 * Initiate the main navigation script.
 */
function initMainNavigation() {
	// Get the submenus.
	const SUBMENUS = document.querySelectorAll( 'li.menu-item-has-children' );

	// No point if no submenus.
	if ( !SUBMENUS.length ) {
		return;
	}

	SUBMENUS.forEach( function ( submenu ) {
		// Toggle the submenu when we click the dropdown button.
		submenu.addEventListener( 'click', function () {
			toggleSubMenu( this );
		} );
	} );
}

/**
 * Toggle submenus open and closed and tell screen readers what's going on.
 */
function toggleSubMenu( parentMenuItem, forceToggle ) {
	const toggleButton = parentMenuItem.querySelector( '.dropdown-toggle' );
	const subMenu = parentMenuItem.querySelector( 'ul' );
	let parentMenuItemToggled = parentMenuItem.classList.contains( 'toggled-on' );

	// Will be true if we want to force the toggle on, false if force toggle close.
	if ( undefined !== forceToggle && 'boolean' == ( typeof forceToggle ) ) {
		parentMenuItemToggled = !forceToggle;
	}

	// Toggle aria-expanded status.
	toggleButton.setAttribute( 'aria-expanded', ( !parentMenuItemToggled ).toString() );

	/*
	 * Steps to handle during toggle:
	 * - Let the parent menu item know we're toggled on/off.
	 * - Toggle the ARIA label to let screen readers know will expand or collapse.
	 */
	if ( parentMenuItemToggled ) {
		// Toggle "off" the submenu.
		parentMenuItem.classList.remove( 'toggled-on' );
		subMenu.classList.remove( 'toggled-on' );
		toggleButton.classList.remove( 'toggled-on' );

		// Make sure all children are closed.
		parentMenuItem.querySelectorAll( '.toggled-on' ).forEach( function ( item ) {
			toggleSubMenu( item );
		} );
	} else {
		// Toggle "on" the submenu.
		toggleButton.classList.add( 'toggled-on' );
		parentMenuItem.classList.add( 'toggled-on' );
		subMenu.classList.add( 'toggled-on' );
	}
}

document.addEventListener( 'DOMContentLoaded', function () {
	const expandableButtons = document.querySelectorAll( '.glue-zippy-btn' );

	expandableButtons.forEach( function ( button ) {
		button.addEventListener( 'click', function () {
			const section = this.closest( '.glue-zippy' );
			const isExpanded = this.getAttribute( 'aria-expanded' ) === 'true';

			this.setAttribute( 'aria-expanded', !isExpanded );
			section.classList.toggle( 'glue-is-expanded' );
		} );

		// Keyboard support
		button.addEventListener( 'keydown', function ( e ) {
			if ( e.key === 'Enter' || e.key === ' ' ) {
				e.preventDefault();
				this.click();
			}
		} );
	} );
} );
